export default "__VITE_ASSET__DSC3HDWa__"